t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <CountImageInput
        :question="$t('home-size.question')"
        :counter.sync="squareMeters"
        :image="require('@/assets/home-size.svg')"
      >
      </CountImageInput>
      <one-button
        type="primary"
        class="next-btn"
        :class="{ disabled: squareMeters <= 0 }"
        @click.native="next()"
      >
        {{ $t('next') }}
      </one-button>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
  import {mapMutations} from "vuex";
  import CountImageInput from "../../components/CountImageInput";
  import CalculatorHeading from "../../components/CalculatorHeading";
  import {getPrevStepUrl, getStepIndex, redirectToUnselectedStepIfAny} from "@/utils/steps.js";
  import {goToNextStep} from "../../utils/steps";

  export default {
  name: "HomeSize",
  components: { CalculatorHeading, CountImageInput },
  data() {
    return {
      step: getStepIndex("home-size"),
      getPrevStepUrl: getPrevStepUrl,
      squareMeters: this.$store.state.data.squareMeters
    };
  },
  watch: {
    squareMeters: function() {
      this.updateSquareMeters(this.squareMeters);
    }
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateSquareMeters"]),
    next() {
      goToNextStep(this.step, this.$i18n.locale, this.$router);
    }
  }
};
</script>

<style scoped>
.calculator {
  align-items: center;
}
</style>
